export const volumes = [
  {
    number: '01',
    title: 'Didáctica y planificación para instructores',
    body: 'Organizá tus capacitaciones con objetivos claros, contenidos estructurados y estrategias didácticas para aprovechar mejor el tiempo y facilitar el aprendizaje.',
    flow: ['Planificar', 'Organizar', 'Enseñar'],
  },
  {
    number: '02',
    title: 'Fundamentos técnicos bomberiles',
    body: 'Contenidos esenciales sobre fuego, combustión, clasificación de fuegos, herramientas y equipamiento, explicados mediante recursos didácticos e ilustraciones.',
    flow: ['Comprender', 'Explicar', 'Reforzar'],
  },
  {
    number: '03',
    title: 'Seguridad y prevención de riesgos',
    body: 'Material educativo sobre identificación de peligros, prevención de incidentes, equipos de protección y cultura de seguridad.',
    flow: ['Identificar', 'Prevenir', 'Proteger'],
  },
  {
    number: '04',
    title: 'Comunicación, liderazgo y trabajo en equipo',
    body: 'Herramientas para enseñar comunicación efectiva, cooperación, liderazgo, coordinación y trabajo en equipo mediante actividades educativas.',
    flow: ['Comunicar', 'Coordinar', 'Trabajar en equipo'],
  },
  {
    number: '05',
    title: '40 escenarios de entrenamiento listos',
    body: 'Una biblioteca de 40 escenarios educativos para trabajar situaciones ficticias, promover el análisis y fomentar la participación de los aspirantes.',
    flow: ['Analizar', 'Participar', 'Aprender'],
  },
  {
    number: '06',
    title: 'Evaluación y seguimiento de aspirantes',
    body: 'Recursos para evaluar conocimientos, registrar resultados, identificar dificultades y acompañar el progreso de los alumnos.',
    flow: ['Evaluar', 'Registrar', 'Mejorar'],
  },
];
